<div class="modal-header">
  <h4 class="modal-title" *ngIf="type === 'help'">Como podemos ajudar?</h4>
  <h4 class="modal-title" *ngIf="type === 'training'">Acesso ao treinamento</h4>
  <button
    class="close"
    (click)="modal.close(false)"
    type="button"
    aria-label="Close button"
    aria-describedby="modal-title">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="padding-top: 0px">
  <form [formGroup]="messageForm">
    <div class="form-group">
      <label>Assunto</label>
      <input class="form-control" placeholder="" formControlName="subject" />
    </div>

    <div class="form-group">
      <label>Mensagem</label>
      <textarea
        class="form-control"
        rows="4"
        placeholder="Informe sua dúvida ou sugestão..."
        formControlName="message"></textarea>
    </div>
  </form>

  <div class="row">
    <div class="col-12 form-group" *ngIf="type === 'training'">
      <label for="file"
        >Arquivo*
        <i
          class="fas fa-question"
          container="body"
          placement="bottom"
          ngbTooltip="Tamanho máximo permitido é de 100mb"></i>
      </label>
      <app-evo-upload-file-input
        [(ngModel)]="file"
        [disabled]="file.length > 0"
        [accept]="acceptTypes"
        [violatedRules]="violatedRulesFileUpload"
        [isProgressBarEnable]="true"
        [actionText]="'escolher'"
        [uploadProgress]="[uploadProgress]"
        [isLoading]="isLoading"
        [isMultiple]="false"
        (cancelUpload)="cancelUpload()"
        name="file"
        style="width: 100%"
        fileLegend="Tamanho máximo permitido é de 100mb">
      </app-evo-upload-file-input>
    </div>
  </div>
</div>
<div class="modal-footer standard-footer">
  <app-standard-footer-buttons
    [secondaryLabel]="'Fechar'"
    [primaryLabel]="'Enviar'"
    [isLoading]="isLoading"
    [isPrimaryDisabled]="isLoading || messageForm.invalid"
    (secondaryClick)="modal.close(false)"
    (primaryClick)="postMessage()">
  </app-standard-footer-buttons>
</div>
